import React from 'react';
import moment from 'moment';
import {
  date, object, mixed, ref,
} from 'yup';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { env } from '~/commons/config';

const defaults = {
  from: '',
  to: '',
  rate: 0,
  startAt: '',
};
const schema = object({
  from: mixed().required().oneOf(env.exchangeCurrency),
  to: mixed()
    .required()
    .when('from', {
      is: (f) => f,
      then: (s) => s.notOneOf([ref('from')], 'Invalid currency'),
    })
    .oneOf(env.exchangeCurrency),
  rate: 0,
  startAt: date().required(),
});

const FormExchangeRate = ({ exchangeRate }) => (
  <FormResource
    {...{
      defaults,
      schema,
      stored: exchangeRate
        ? {
          ...exchangeRate,
          startAt: exchangeRate.startAt
            ? moment(exchangeRate.startAt).format('YYYY-MM-DD')
            : '',
        }
        : undefined,
      onSubmit: (vs) => ({
        ...vs,
        startAt: moment(vs.startAt, 'YYYY-MM-DD').toDate(),
      }),
      api: '/api/core/exchange-rates',
    }}
  >
    <div className="row">
      <div className="col">
        <FormGroup name="from" />
      </div>
      <div className="col">
        <FormGroup name="to" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="rate" label="Exchange Rate" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <FormGroup name="startAt" type="date" />
      </div>
    </div>
  </FormResource>
);

export default FormExchangeRate;
